import { render, staticRenderFns } from "./ContextMenu.vue?vue&type=template&id=0050c611&lang=pug"
import script from "./ContextMenu.vue?vue&type=script&lang=ts"
export * from "./ContextMenu.vue?vue&type=script&lang=ts"
import style0 from "./ContextMenu.vue?vue&type=style&index=0&id=0050c611&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports